window.$ = window.jQuery = require('jquery');
import Bloodhound from 'corejs-typeahead';
import moment from 'moment';

var $search;

const engines = {
  customers: new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: customer => customer.id,
    limit: 100,
    remote: {
      url: '/customers/search?q=%QUERY',
      wildcard: '%QUERY',
      transform (response) {
        return response.map(customer => {
          customer.url = '/customers/' + customer.id;
          return customer;
        });
      }
    }
  }),

  orders: new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: order => order.id,
    limit: 100,
    remote: {
      url: '/orders/search?q=%QUERY',
      wildcard: '%QUERY',
      transform (response) {
        return response.map(order => {
          order.url = '/orders/' + order.id;
          return order;
        });
      }
    }
  }),

  products: new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: product => product.id,
    limit: 100,
    remote: {
      url: '/products/search?q=%QUERY',
      wildcard: '%QUERY',
      transform (response) {
        return response.map(product => {
          product.url = '/products/' + product.id;
          return product;
        });
      }
    }
  })
};

const datasets = {
  customers: {
    name: 'customers',
    display: 'name',
    limit: 50,
    source: engines.customers,
    templates: {
      notFound: '<div class="tt-empty text-muted">Δε βρέθηκαν πελάτες.</div>',
      header: '<div class="tt-header bg-purple">Πελάτες</div>',
      suggestion (customer) {
        return `
          <div>
            <strong>${customer.last_name} ${customer.first_name}</strong>
            <span class="text-muted"><br>${customer.email || ''}<br>${customer.phone || customer.mobile}</span>
          </div>`;
      }
    }
  },

  orders: {
    name: 'orders',
    display: 'id',
    source: engines.orders,
    limit: 50,
    templates: {
      notFound: '<div class="tt-empty text-muted">Δε βρέθηκαν παραγγελίες.</div>',
      header: '<div class="tt-header bg-purple">Παραγγελίες</div>',
      suggestion (order) {
        return `
          <div>
            <strong>${order.id}</strong>
            <span class="text-muted"><br>${ order.last_name } ${ order.first_name }</span>
            <span class="text-muted"><br>${ moment(order.date).format('ll') }</span>
          </div>`;
      }
    }
  },

  products: {
    name: 'products',
    display: 'name',
    source: engines.products,
    limit: 50,
    templates: {
      notFound: '<div class="tt-empty text-muted">Δε βρέθηκαν προϊόντα.</div>',
      header: '<div class="tt-header bg-purple">Προϊόντα</span></div>',
      suggestion (product) {
        return `
          <div class="media">
            <div class="media-left media-middle">
              <img src="${product.thumbnail}" alt="${product.name}" width="50">
            </div>
            <div class="media-body media-middle">
              <strong class="text-darker">${product.name}</strong>
              <div class="text-muted">
                ${product.stores.map(store => store.name).join(', ')}
              </div>
            </div>
          </div>`;
      }
    }
  }
};

$(() => init());

function init() {
  $search = $('#search');

  $search.find('input').typeahead({
    debug: true,
    highlight: true,
    hint: true,
    minLength: 3,
  },
  datasets.orders,
  datasets.customers,
  datasets.products
  );

  _bindEvents();
}

function _bindEvents() {
  $search
    .on('typeahead:select', _redirect)
    .on('typeahead:asyncrequest', () => {
      $search.find('input').addClass('loading');
    })
    .on('typeahead:render', () => {
      $search.find('input').removeClass('loading');
    });
}

function _redirect(e, suggestion) {
  window.location.href = suggestion.url;
}

